exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".HomeDialogDetail-header{display:flex;align-items:center;justify-content:space-between;background-color:#eee;font-size:16px;padding:0 10px 0 30px;margin:20px 0}.HomeDialogDetail-content{padding:10px 30px 10px 0;border-right:1px solid #c0ccda}.border-none{border:none}.HomeDialogDetail-content .el-radio{width:auto;display:inline-block}.HomeDialogDetail-content .formItems{display:inline-block;width:220px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-85f8e644!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/HomeDialog/detail.vue
// module id = 599
// module chunks = 0